import { Box, Typography } from "@outschool/backpack";
import { ClassDetailsQuery_ActivityFragment } from "@outschool/gql-frontend-generated";
import { Trans, useTranslation } from "@outschool/localization";
import React from "react";

import usePriceDetailsString from "../hooks/usePriceDetailsString";

export default function PriceLineItem({
  activity,
}: {
  activity: ClassDetailsQuery_ActivityFragment;
}) {
  const { t } = useTranslation(
    "ui-components-website\\ClassDetailsPage\\PriceLineItem"
  );

  const { perMeetingPriceString, totalPriceString, weeklyPriceString } =
    usePriceDetailsString();
  let text;
  if (activity.hasTeacherSchedule) {
    text = (
      <Trans t={t}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {{ perMeetingPrice: perMeetingPriceString(activity) } as any}
        </Typography>
        <Typography> per session</Typography>
      </Trans>
    );
  } else if (activity.isOneTime) {
    text = (
      <Trans t={t}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {{ perMeetingPrice: perMeetingPriceString(activity) } as any}
        </Typography>
        <Typography> per class</Typography>
      </Trans>
    );
  } else if (activity.isClub) {
    text = (
      <Trans t={t}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {{ perMeetingPrice: perMeetingPriceString(activity) } as any}
        </Typography>
        <Typography> monthly</Typography>
      </Trans>
    );
  } else if (activity.isSelfPaced) {
    if (activity.duration_weeks === 1) {
      text = (
        <Trans t={t}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {{ totalPrice: totalPriceString(activity) } as any}
          </Typography>
          <Typography> for all content</Typography>
        </Trans>
      );
    } else {
      text = (
        <>
          <Trans t={t}>
            <Typography variant="h4" sx={{ fontWeight: 700 }}>
              {{ weeklyPrice: weeklyPriceString(activity) } as any}
            </Typography>
            <Typography> weekly</Typography>
          </Trans>
        </>
      );
    }
  } else if (activity.is_ongoing_weekly && activity.weekly_meetings === 1) {
    text = (
      <Trans t={t}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {{ weeklyPrice: weeklyPriceString(activity) } as any}
        </Typography>
        <Typography> weekly</Typography>
      </Trans>
    );
  } else if (
    activity.is_ongoing_weekly &&
    (activity.weekly_meetings || 0) > 1
  ) {
    text = (
      <Trans t={t}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {{ weeklyPrice: weeklyPriceString(activity) } as any}
        </Typography>
        <Typography> weekly (</Typography>
        <Typography sx={{ fontWeight: 700 }}>
          {{ perMeetingPrice: perMeetingPriceString(activity) } as any}
        </Typography>
        <Typography> per class)</Typography>
      </Trans>
    );
  } else if (activity.isFlexSchedule && !activity.allows_recurring_payment) {
    text = (
      <Trans t={t}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {{ totalPrice: totalPriceString(activity) } as any}
        </Typography>
        <Typography>
          {" "}
          for {{ duration: activity.duration_weeks } as any} weeks
        </Typography>
      </Trans>
    );
  } else if (activity.isFlexSchedule && activity.allows_recurring_payment) {
    text = (
      <>
        <Trans t={t}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {{ weeklyPrice: weeklyPriceString(activity) } as any}
          </Typography>
          <Typography> weekly</Typography>
        </Trans>
      </>
    );
  } else if (!activity.allows_recurring_payment) {
    text = (
      <Trans t={t}>
        <Typography variant="h4" sx={{ fontWeight: 700 }}>
          {{ totalPrice: totalPriceString(activity) } as any}
        </Typography>
        <Typography>
          {" "}
          for{" "}
          {{
            classes:
              (activity.duration_weeks || 0) * (activity.weekly_meetings || 0),
          }}{" "}
          classes
        </Typography>
      </Trans>
    );
  } else if (activity.allows_recurring_payment) {
    text = (
      <>
        <Trans t={t}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            {{ weeklyPrice: weeklyPriceString(activity) } as any}
          </Typography>
          <Typography> weekly</Typography>
        </Trans>
      </>
    );
  }
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "baseline",
        whiteSpace: "pre-wrap",
        flexWrap: "wrap",
      }}
    >
      {text}
    </Box>
  );
}
